module.exports = __webpack_public_path__ + "img/ic_notification_referral.1dd8ff5f.svg";